import React from "react";
import exterior_001 from "./images/exterior_001.jpg";
import { Waves, TreePine, PawPrint, Moon, Sofa, Home } from "lucide-react";

function About() {
  try {
    const features = [
      {
        icon: <Waves size={40} color="#b86a4b" />,
        title: "Swimming Pool",
        description:
          "Relax in our beautiful swimming pool with crystal clear water",
      },
      {
        icon: <TreePine size={40} color="#b86a4b" />,
        title: "Garden",
        description: "Enjoy the lush green garden with beautiful landscaping",
      },
      {
        icon: <PawPrint size={40} color="#b86a4b" />,
        title: "Pet-Friendly",
        description:
          "Bring your furry friends along for the perfect family vacation",
      },
      {
        icon: <Moon size={40} color="#b86a4b" />,
        title: "Night Lighting",
        description: "Beautiful ambient lighting creates magical evenings",
      },
      {
        icon: <Sofa size={40} color="#b86a4b" />,
        title: "Outdoor Seating",
        description: "Comfortable outdoor spaces for relaxation and gatherings",
      },
      {
        icon: <Home size={40} color="#b86a4b" />,
        title: "8BHK Villa",
        description: "Spacious accommodation for large groups and families",
      },
    ];

    return (
      <section
        className="section-padding bg-white px-4 sm:px-6 lg:px-8"
        data-name="about"
        data-file="components/About.js"
      >
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-6">
              About Angelo's Farm
            </h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto">
              Nestled in the peaceful location of Kukas, Jaipur, Angelo's Farm
              offers a luxurious retreat where comfort meets elegance. Our 8BHK
              villa provides the perfect setting for unforgettable memories with
              family and friends.
            </p>
          </div>

          {/* Features Grid - Horizontal Scroll */}
          <div className="overflow-x-auto mb-10 pb-2 scrollbar-hide">
            <div className="flex space-x-4 min-w-max justify-center md:justify-center lg:justify-center xl:justify-center">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center bg-white rounded-2xl shadow-md px-4 py-5 min-w-[110px] max-w-[120px] border-2 border-[#B86A4B] flex-shrink-0"
                >
                  <div className="mb-2" style={{ color: "#B86A4B" }}>
                    {feature.icon}
                  </div>
                  <span className="text-sm font-bold text-[#B86A4B] text-center leading-tight">
                    {feature.title}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Location Info */}
          <div className="luxury-border p-8 md:p-12 rounded-3xl bg-gradient-to-r from-orange-50/80 to-stone-50/80 backdrop-blur-sm">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-serif font-bold text-stone-800 mb-4">
                  Perfect Location
                </h3>
                <p className="text-lg text-stone-600 mb-6">
                  Located in Kukas, Jaipur, Angelo's Farm offers the perfect
                  blend of tranquility and accessibility. Enjoy the peaceful
                  countryside while being close to Jaipur's attractions.
                </p>
                <div className="flex items-center space-x-4">
                  <div className="flex items-center text-stone-700">
                    <div className="icon-map-pin text-lg mr-2"></div>
                    <span>Kukas, Jaipur</span>
                  </div>
                  <div className="flex items-center text-stone-700">
                    <div className="icon-clock text-lg mr-2"></div>
                    <span>24/7 Available</span>
                  </div>
                </div>
              </div>
              <div className="relative">
                <img
                  src={exterior_001}
                  alt="Angelo's Farm Location"
                  className="w-full h-150 object-cover rounded-2xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  } catch (error) {
    console.error("About component error:", error);
    return null;
  }
}

export default About;
